import { SocialMediaIcon, SocialPlateforms } from '@nextgen-web-framework/all';
import styles from './SocialLink.module.scss';
export interface SocialLinkProps {
  iconName: SocialPlateforms;
  iconTitle: string;
  iconClickHandler: (iconName: SocialPlateforms) => void;
}
const SocialLink = ({ iconName, iconTitle, iconClickHandler }: SocialLinkProps) => (
  <div
    role="presentation"
    onClick={() => iconClickHandler(iconName)}
    className={styles['social-icon-wrapper']}
    data-testid={`social-link-${iconName}-test-id`}
  >
    <SocialMediaIcon iconName={iconName} />
    <div className={`${styles['social-icon-title']}`}>{iconTitle}</div>
  </div>
);

export default SocialLink;
